module.exports = __webpack_public_path__ + "static/media/endotelio.99412e51.jpg";